import { createSelector } from 'reselect'
import firstBy from 'thenby'

export const getSecretToken = ({ secretToken }) => secretToken
export const getSurveyState = ({ surveyState }) => surveyState
export const getCurrentQuestionId = ({ currentQuestionId }) => currentQuestionId
export const getQuestionsById = ({ survey }) => survey.questionsById || {}
const getOptionChoicesByOptionGroupId = ({ survey }) =>
  survey.optionChoicesByOptionGroupId || {}
const getDriversById = ({ survey }) => survey.driversById || {}
export const getAnswersByQuestionId = ({ answersByQuestionId }) =>
  answersByQuestionId
export const getCommentsByQuestionId = ({ commentsByQuestionId }) =>
  commentsByQuestionId
export const getLocation = ({ location }) => location

export const getLocationType = createSelector(
  getLocation,
  location => location.type
)

export const getCurrentQuestion = createSelector(
  getQuestionsById,
  getCurrentQuestionId,
  (questionsById, id) => questionsById[id]
)

export const getCurrenOptionGroupChoices = createSelector(
  getOptionChoicesByOptionGroupId,
  getCurrentQuestion,
  (optionChoicesByOptionGroupId, { optionGroupId }) =>
    optionChoicesByOptionGroupId[optionGroupId]
)

export const getCurrentDrivers = createSelector(
  getDriversById,
  getCurrentQuestion,
  (driversById, { driverIds }) => driverIds.map(id => driversById[id])
)

export const getCurrentAnswer = createSelector(
  getAnswersByQuestionId,
  getCurrentQuestionId,
  (answersByQuestionId, questionId) => answersByQuestionId[questionId]
)

export const getCurrentComment = createSelector(
  getCommentsByQuestionId,
  getCurrentQuestionId,
  (commentsByQuestionId, questionId) => commentsByQuestionId[questionId] || ''
)

export const getIsCurrentQuestionAnswered = createSelector(
  getCurrentAnswer,
  answer => !!answer
)

export const getIsCurrentQuestionCommentsAllowed = createSelector(() => true)

export const getIsCommentFieldEnabled = createSelector(
  getIsCurrentQuestionCommentsAllowed,
  getIsCurrentQuestionAnswered,
  (commentsAllowed, questionAnswered) => commentsAllowed && questionAnswered
)

export const getQuestions = createSelector(getQuestionsById, questionsById =>
  Object.values(questionsById).sort(firstBy('sortOrder').thenBy('id'))
)

export const getIsCurrentQuestionLastInSurvey = createSelector(
  getCurrentQuestion,
  getQuestions,
  (question, questions) => questions.length === questions.indexOf(question) + 1
)

export const getQuestionIds = createSelector(getQuestions, questions =>
  questions.map(({ id }) => id)
)

export const getFirstQuestion = createSelector(
  getQuestions,
  questions => questions[0]
)

export const getFirstQuestionId = createSelector(
  getFirstQuestion,
  question => (question ? question.id : null)
)

export const getNextQuestion = createSelector(
  getQuestions,
  getCurrentQuestion,
  (questions, question) => questions[questions.indexOf(question) + 1]
)

export const getNextQuestionId = createSelector(
  getNextQuestion,
  question => question && question.id
)

export const getSurveyProgress = createSelector(
  getAnswersByQuestionId,
  getQuestions,
  getCurrentQuestionId,
  (answersByQuestionId, questions, currentQuestionId) =>
    questions.map(({ id }) => ({
      questionId: id,
      hasAnswer: !!answersByQuestionId[id],
      isCurrentQuestion: id === currentQuestionId,
    }))
)

export const getCurrentAnswerOptionChoice = createSelector(
  getCurrenOptionGroupChoices,
  getCurrentAnswer,
  (choices, answer) =>
    answer ? choices.find(({ id }) => id === answer.optionChoiceId) : undefined
)

export const getCurrentAnswerOptionChoiceId = createSelector(
  getCurrentAnswerOptionChoice,
  choice => (choice ? choice.id : undefined)
)



// WEBPACK FOOTER //
// ./src/selectors.js